module.exports = __webpack_public_path__ + "static/media/gl.c6090a99.svg";